export enum InterestedParty {
    HOVEDLAANTAKER = 'HOVEDLAANTAKER',
    MEDLAANTAKER = 'MEDLAANTAKER',
    KAUSJONIST = 'KAUSJONIST',
    INNEHAVER = 'INNEHAVER',
}

export enum ConsentAssignmentStatus {
    UNOPENED = 'UNOPENED',
    OPENED = 'OPENED',
    ACCEPTED = 'ACCEPTED',
    REJECTED = 'REJECTED',
    EXPIRED = 'EXPIRED',
    UNKNOWN = 'UNKNOWN',
}
